import { Client } from 'appwrite';

export const appwriteConfig = {
  endpoint: import.meta.env.VITE_APPWRITE_ENDPOINT ?? 'https://api.orun.site/v1',
  projectId: import.meta.env.VITE_APPWRITE_PROJECT_ID ?? '6a8f0a6d003d31b2f082',
  projectName: import.meta.env.VITE_APPWRITE_PROJECT_NAME ?? 'orun',
};

export const appwriteClient = new Client()
  .setEndpoint(appwriteConfig.endpoint)
  .setProject(appwriteConfig.projectId);

export async function checkAppwriteConnection(): Promise<boolean> {
  try {
    const response = await fetch(appwriteConfig.endpoint + '/health/version', {
      headers: {
        'X-Appwrite-Project': appwriteConfig.projectId,
      },
    });
    return response.ok;
  } catch {
    return false;
  }
}
